<h2 *ngIf="!modeInline" class="counter-title">
  {{ message | translate:{
  count: count,
  plural: count > 1 ? 's' : ''
  }
  }}
</h2>

<span *ngIf="modeInline" class="counter-title">
  {{ message | translate:{
  count: count,
  plural: count > 1 ? 's' : ''
  }
  }}
</span>